/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '../../application';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { getAgent } from './agent';

import {
  IGetCredentialIssuedListProps,
  SelectedCredentialsProps,
} from './components';

const is = require('is_js');

const SERVICE_NAME = 'UnderReviewEPortfolioCertificatesPageService';
const log: any = LoggerModule.getInstance();

export type IUnderReviewEPortfolioCertificatePageSrvGetPageContentArgs =
  IGetCredentialIssuedListProps;

export class UnderReviewEPortfolioCertificatesPageService {
  private static instance: UnderReviewEPortfolioCertificatesPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): UnderReviewEPortfolioCertificatesPageService {
    if (!UnderReviewEPortfolioCertificatesPageService.instance) {
      UnderReviewEPortfolioCertificatesPageService.instance =
        new UnderReviewEPortfolioCertificatesPageService(props);
    }
    return UnderReviewEPortfolioCertificatesPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(
    args: IUnderReviewEPortfolioCertificatePageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getCredentialIssuedListsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async submitCred(args: SelectedCredentialsProps) {
    console.log(`submit credential ids`, args);
    const agent = getAgent();
    return agent.getSelectedCredentials(args);
  }
}
